import React from "react"
import PropTypes from "prop-types"


const Content = ({ text, children }) => {
  return <div>
           {children || text}
         </div>
}

Content.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

export { Content }
